export type JsonPrimitive = string | number | boolean | null;
export type JsonValue = JsonPrimitive | JsonObject | JsonValue[];

export type JsonObject = Record<string, JsonValue>;

export const cleanExampleObjectForEditing = (
  obj: JsonObject,
  keysToKeep: Set<string>,
): JsonObject => {
  const cleaned: JsonObject = {};

  for (const [key, value] of Object.entries(obj)) {
    if (keysToKeep.has(key)) {
      cleaned[key] = value;
    } else if (typeof value === 'boolean') {
      cleaned[key] = false;
    } else if (value === null) {
      cleaned[key] = null;
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        cleaned[key] = value.map((item) => {
          if (typeof item === 'object' && item !== null) {
            return cleanExampleObjectForEditing(item as JsonObject, keysToKeep);
          }

          return typeof item === 'boolean' ? false : '';
        });
      } else {
        cleaned[key] = cleanExampleObjectForEditing(value, keysToKeep);
      }
    } else {
      cleaned[key] = '';
    }
  }

  return cleaned;
};
